/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	'use strict';
	/*globals Tc */

	/**
	 * SupportAgentStatus
	 *
	 * @author Walid Ghazzo
	 * @namespace Tc.Module
	 * @class SupportAgentStatus
	 * @extends Tc.Module
	 */

	Tc.Module.SupportAgentStatus = Tc.Module.extend({

		on: function(callback) {

			$('html').addClass('hasAdditionalTopBar');
			callback();

		}

	});
}(Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.SupportAgentStatus.js
// module id = 185
// module chunks = 0